﻿namespace Areas {
    "use strict";

    //contract Lookup
    export function contractLookupItem(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(
            `<div><span class="collookupspanid">${itemData.contractNameTypeAmount}</span></div>`);
    }


    //contractorContact Lookup  (from Account Team)
    export function contactLookupItem(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(
            `<div><span class="collookupspanid">${itemData.displayNameCompanyNameRole}</span></div>`);
    } 

    //account Lookup
    export function accountLookupItem(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(`<div><span class="collookupspanaccountName">${itemData.projectCCNumberName}</span></div>`);
    }

    //project Lookup
    export function projectLookupItem(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(`<div><span class="collookupspanprojectName">${itemData.projectNumberName}</span></div>`);
    }

}